import React from 'react';
import HeroSection from '../components/Home/HeroSection';
import HistorySection from '../components/Home/HistorySection';
import CoreServicesSection from '../components/Home/CoreServicesSection';
import FiscalSection from '../components/Home/FiscalSection';
import CertificateSection from '../components/Home/CertificateSection';
import DomesticIrpfSection from '../components/Home/DomesticIrpfSection';
import SegurosSection from '../components/Home/SegurosSection';
import IrpfConsultoriaSection from '../components/Home/IrpfConsultoriaSection';
import TimelineSection from '../components/Home/TimelineSection';
import WhyUsSection from '../components/Home/WhyUsSection';
import FaqSection from '../components/Home/FaqSection';

import CTABanner from '../components/Home/CTABanner';
import StatsSection from '../components/Home/StatsSection';
import ClientsCarousel from '../components/Home/ClientsCarousel';

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <HeroSection />
      
      <ClientsCarousel />
      
      <HistorySection />

      <StatsSection />
      
      <CoreServicesSection />
      
      <FiscalSection />
      
      <CTABanner 
        title="O Compliance que sua empresa merece." 
        subtitle="Evite multas e reduza impostos com nossa auditoria fiscal avançada."
      />
      
      <CertificateSection />
      
      <DomesticIrpfSection />
      
      <SegurosSection />
      
      <IrpfConsultoriaSection />
      
      <CTABanner 
        title="Blindagem Patrimonial 360º" 
        subtitle="Proteja seus ativos pessoais e garanta o futuro da sua família."
        btnText="Solicitar Diagnóstico"
      />
      
      <TimelineSection />
      
      <WhyUsSection />
      
      <FaqSection />
      

    </div>
  );
}
